// Mock data for DJ NKEY website

export const djInfo = {
  name: "DJ NKEY",
  tagline: "Професионален DJ за вашето незабравимо събитие",
  heroImage:
    "https://customer-assets.emergentagent.com/job_rhythm-palace-2/artifacts/z1ns63pd_IMG_1929.jpg",
  email: "nkeynanchev@gmail.com",
  phone: "+359 888776055",
  viber: "+359888776055"
};

/* =========================
   MUSIC STYLES (BG + EN)
========================= */

export const musicStyles = [
  {
    id: 1,
    title: "Club Music",
    titleEn: "Club Music",
    description: "Afro / Funky / Tech-House + Freestyle",
    descriptionEn: "Afro / Funky / Tech-House + Freestyle",
    icon: "Music"
  },
  {
    id: 2,
    title: "Commercial Music",
    titleEn: "Commercial Music",
    description: "Вечните поп-хитове",
    descriptionEn: "Timeless pop hits",
    icon: "Radio"
  },
  {
    id: 3,
    title: "Retro Hits",
    titleEn: "Retro Hits",
    description: "80's, 90's, 2000's - класиките които всички обичат",
    descriptionEn: "80's, 90's, 2000's classics everyone loves",
    icon: "Disc3"
  },
  {
    id: 4,
    title: "Balkan Party",
    titleEn: "Balkan Party",
    description: "Гръцки, Сръбски и балкански ритми",
    descriptionEn: "Greek, Serbian and Balkan rhythms",
    icon: "Headphones"
  },
  {
    id: 5,
    title: "Българска музика",
    titleEn: "Bulgarian Music",
    description: "BG Pop & Pop-Folk",
    descriptionEn: "BG Pop & Pop-Folk",
    icon: "Music"
  },
  {
    id: 6,
    title: "...и много други",
    titleEn: "...and many more",
    description: "Разнообразен репертоар за всеки вкус и събитие",
    descriptionEn: "Diverse repertoire for every taste and event",
    icon: "Radio"
  }
];

/* =========================
   EXPERIENCES (BG + EN)
========================= */

export const experiences = [
  {
    id: 1,
    title: "Aura / Bamboo / Bamboo Beach",
    titleEn: "Aura / Bamboo / Bamboo Beach",
    venue: "София и Созопол",
    venueEn: "Sofia & Sozopol",
    description: "DJ сетове в заведенията от веригата",
    descriptionEn: "DJ sets in venues from the chain"
  },
  {
    id: 2,
    title: "Corner Piano Bar",
    titleEn: "Corner Piano Bar",
    venue: "София",
    venueEn: "Sofia",
    description: "Разнообразна програма с изпълнители на живо",
    descriptionEn: "Live performer programs"
  },
  {
    id: 3,
    title: "Gramophone Club",
    titleEn: "Gramophone Club",
    venue: "София",
    venueEn: "Sofia",
    description: "Корпоративни партита до зори",
    descriptionEn: "Corporate parties until sunrise"
  },
  {
    id: 4,
    title: "Largo di Serdika",
    titleEn: "Largo di Serdika",
    venue: "София Център",
    venueEn: "Sofia Center",
    description: "House сетове & латино програми",
    descriptionEn: "House sets & Latino programs"
  },
  {
    id: 5,
    title: "Machete Beach Bar",
    titleEn: "Machete Beach Bar",
    venue: "Каваци Созопол",
    venueEn: "Kavatsi, Sozopol",
    description: "Beach Bar Session",
    descriptionEn: "Beach Bar Session"
  },
  {
    id: 6,
    title: "Pulse Fitness",
    titleEn: "Pulse Fitness",
    venue: "София",
    venueEn: "Sofia",
    description: "Мотивиращ микс за тежки тренировки",
    descriptionEn: "Motivating mix for intense workouts"
  },
  {
    id: 7,
    title: "Morgan’s Bar",
    titleEn: "Morgan’s Bar",
    venue: "София",
    venueEn: "Sofia",
    description: "Топ хитове за танци",
    descriptionEn: "Top dance hits"
  },
  {
    id: 8,
    title: "Gravity Bar",
    titleEn: "Gravity Bar",
    venue: "София",
    venueEn: "Sofia",
    description: "Ретро парти",
    descriptionEn: "Retro party"
  },
  {
    id: 9,
    title: "Relax Bar & Dinner",
    titleEn: "Relax Bar & Dinner",
    venue: "София жк. Надежда",
    venueEn: "Sofia, Nadezhda District",
    description: "Гръцко парти",
    descriptionEn: "Greek party"
  }
];

/* =========================
   WHY CHOOSE (BG + EN)
========================= */

export const whyChooseReasons = [
  {
    id: 1,
    title: "Над десет години професионален опит",
    titleEn: "Over 10 years of professional experience",
    description: "Богат опит в индустрията и стотици участия",
    descriptionEn: "Rich experience in the industry and hundreds of events"
  },
  {
    id: 2,
    title: "Изпълнения в най-добрите заведения",
    titleEn: "Performances in top venues",
    description: "Клубове, барове, ресторанти и зали за събития",
    descriptionEn: "Clubs, bars, restaurants and event halls"
  },
  {
    id: 3,
    title: "Опит в озвучаването",
    titleEn: "Sound engineering experience",
    description: "Колаборации и съвместни участия с популярни изпълнители",
    descriptionEn: "Collaborations and joint performances with popular artists"
  }
];

/* =========================
   GALLERY
========================= */

export const gallery = [
  {
    id: 1,
    image:
      "https://customer-assets.emergentagent.com/job_rhythm-palace-2/artifacts/3k13ei1c_IMG_1958.JPG",
    alt: "DJ NKEY Performance"
  },
  {
    id: 2,
    image:
      "https://customer-assets.emergentagent.com/job_rhythm-palace-2/artifacts/kphrxcy3_IMG_1948.jpg",
    alt: "DJ NKEY Studio"
  },
  {
    id: 3,
    image:
      "https://customer-assets.emergentagent.com/job_rhythm-palace-2/artifacts/ar570tqn_IMG_1949.jpg",
    alt: "DJ NKEY Outdoor Event"
  }
];

/* =========================
   SOCIAL LINKS
========================= */

export const socialLinks = {
  facebook:
    "https://www.facebook.com/share/1AZVHCRczF/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/dj_nkey/",
  soundcloud: "https://soundcloud.com/djnkey",
  spotify: "https://spotify.com/djnkey",
  youtube: "https://youtube.com/djnkey"
};
